import {useEffect} from 'react';
import axios from 'axios';
import {useDispatch, useSelector} from "react-redux";

import type {AppEnv} from '~/types/app-env-types';
import Selectors from "~/state/selectors.ts";
import {actions} from "~/state/reducers/app-env-reducer.ts";

export function useAppEnv() {
    const dispatch = useDispatch();
    const serverBase = useSelector(Selectors.getServerBase);

    useEffect(() => {
        dispatch(actions.setFetchingEnv(true));

        if (serverBase != '') {
            axios.get(`${serverBase}/erpui/env.json`)
                .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            const newEnv: AppEnv = {
                                urps: {
                                    serviceUri: response.data.urpsBaseUri,
                                },
                                oidc: {
                                    clientId: response.data.erpuiOidcClientId,
                                    authBaseUrl: response.data.erpuiOidcAuthBaseUrl,
                                    urls: {
                                        login: response.data.erpuiOidcAuthLoginUrl,
                                        logout: response.data.erpuiOidcAuthLogoutUrl,
                                        token: response.data.erpuiOidcAuthTokenUrl,
                                        postLogin: response.data.erpuiOidcAppRedirectUrl,
                                        postLogout: response.data.erpuiOidcAuthLogoutUrl,
                                    },
                                    realm: response.data.erpuiOidcAuthRealm,
                                },
                                usersvc: {
                                    realmId: response.data.userServiceRealmId,
                                    baseUri: response.data.userServiceBaseUri,
                                }
                            };
                            dispatch(actions.setAppEnv({env: newEnv, fetchingEnv: false}));
                        }
                    }
                )
                .catch(() => {})
                .finally(() => dispatch(actions.setFetchingEnv(false)));
        } else {
            dispatch(actions.setFetchingEnv(false));
        }
    }, [dispatch, serverBase]);
}
